import { render } from "./ReplyContents.vue?vue&type=template&id=3435de65&ts=true"
import script from "./ReplyContents.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReplyContents.vue?vue&type=script&setup=true&lang=ts"

import "./ReplyContents.vue?vue&type=style&index=0&id=3435de65&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/reply/ReplyContents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3435de65"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3435de65', __exports__)) {
    api.reload('3435de65', __exports__)
  }
  
  module.hot.accept("./ReplyContents.vue?vue&type=template&id=3435de65&ts=true", () => {
    api.rerender('3435de65', render)
  })

}


export default __exports__